import React from "react";
import { Tooltip } from "hcss-components";
import { strings } from "localization";

export const FullProjectTrackingOnlyTooltip = (
  <Tooltip id="disabledToolTip">
    {strings.schemas.setup.fullProjectTrackingOnly}
  </Tooltip>
);
